<script setup lang="ts">
import HeaderSimple from '~/components/layouts/HeaderSimple.vue'

const NewFooter = defineAsyncComponent(() => import('~/components/layouts/NewFooter.vue'))
</script>

<template>
	<HeaderSimple />
	<slot />
	<NewFooter />
</template>
